import photos from "./workPhotos.json";

export const workPhotos = photos;
export const photoById = id => photos.find(photo => photo.id === id);
export const detailingPhotos = photos.filter(photo => photo.category === "automotive");
export const apartmentPhotos = photos.filter(photo => photo.category === "residential");
export const portfolioForService = { detailing: detailingPhotos, apartment: apartmentPhotos };
export const photoLabel = (photo, t) => `${t(`services.items.${photo.service === "detailing" ? "detailing" : "apartment"}.title`)} · ${Number(photo.id.split("-")[1])}`;